import { ProposalInflowsSection } from 'Organisms/ProposalInflowsSection';
import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { FDContentContainer } from '@facet-wealth/design';
import { MoneyflowsSectionTabWrapper } from './MoneyflowsSectionTabWrapper';

export const ProposalInflowsSectionTabWrapper = ({ resource }) => {
  return (
    <FDContentContainer maxWidth={'lg'}>
      <MoneyflowsSectionTabWrapper>
        <ProposalInflowsSection resource={resource} />
      </MoneyflowsSectionTabWrapper>
    </FDContentContainer>
  );
};

ProposalInflowsSectionTabWrapper.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
